import { getDataMapper, mapField, mapArray } from "@/shared";

export const mapRentToCancelToServer = getDataMapper({
    rent_id: mapField("id", Number),
});

export const mapRentsToCancelToServer = mapArray(mapRentToCancelToServer);
